<script>
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import { useDateTime } from "@/composables/index.ts";

const { dateTZ } = useDateTime();

export default {
  name: "OnlineStatus",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    mobileUserLastOnline() {
      return this.dispatcher ? dateTZ(this.user.mobileUserLastOnline, this.dispatcher.timezone) : "";
    },
  },
};
</script>

<template>
  <span v-if="user.mobileUserLastOnline">
    {{ mobileUserLastOnline }}
  </span>
  <span v-else>The user hasn’t yet logged in the app.</span>
</template>

<style lang="scss" scoped></style>
